import {
  isBookRoute,
  isCurrentUnit,
  isFinanceRoute,
  isPlayRoute,
  isPodRoute,
  isScienceRoute,
  isSubscriptionRoute,
  isSubscriptionSiktRoute,
} from "@/utils/url";
import Icon from "./icon";

const Logo = ({
  path,
  accentColor,
  currentUnit,
}: {
  path: string | undefined;
  accentColor?: string;
  currentUnit?: string | null;
}) => {
  if (!path) return null;

  if (
    isFinanceRoute(path) ||
    isSubscriptionRoute(path) ||
    isCurrentUnit("unit-finansmagasinet", currentUnit)
  )
    return <Icon.LogoFinance className="h-[38px] max-w-[45vw]" />;

  if (isPlayRoute(path) || isCurrentUnit("unit-play", currentUnit))
    return (
      <>
        <Icon.LogoPlay className="hidden sm:block h-[50px]" />
        <Icon.Logo className="block sm:hidden fill-gray-500  h-[50px]" />
      </>
    );

  if (isPodRoute(path) || isCurrentUnit("unit-pod", currentUnit))
    return (
      <>
        <Icon.LogoPod className="hidden sm:block h-[50px]" />
        <Icon.Logo className="block sm:hidden fill-gray-500  h-[50px]" />
      </>
    );
  if (
    isBookRoute(path) ||
    isSubscriptionSiktRoute(path) ||
    isCurrentUnit("unit-bok", currentUnit)
  )
    return (
      <>
        <Icon.LogoBook className="hidden sm:block h-[50px]" />
        <Icon.Logo className="block sm:hidden fill-gray-500  h-[50px]" />
      </>
    );

  if (isScienceRoute(path) || isCurrentUnit("unit-vetenskap", currentUnit))
    return (
      <>
        <Icon.LogoScience className="hidden sm:block h-[50px]" />
        <Icon.Logo className="block sm:hidden fill-gray-500  h-[50px]" />
      </>
    );

  return (
    <>
      <Icon.LogoEfn
        className="hidden sm:block fill-gray-500  h-[50px]"
        accentColor={accentColor}
      />
      <Icon.Logo className="block sm:hidden fill-gray-500  h-[50px]" />
    </>
  );
};
export default Logo;
